export function getSeatCode(seatType = "", consoleWidthSelection = "") {
  let consoleWidth = consoleWidthSelection.split("_")[3]?.replace(".", "_");

  let seatCode = "";

  if (consoleWidth === "4") {
    seatCode = "D19P4C";
  }
  if (consoleWidth === "5_5") {
    seatCode = "D19P55C";
  }
  if (consoleWidth === "6_5") {
    seatCode = "D19P65C";
  }
  if (consoleWidth === "8_5") {
    seatCode = "D19P85C";
  }
  if (seatType.indexOf("widebody_pax_number_quad") > -1) {
    seatCode = "Q19P4C";
  }
  if (seatType.indexOf("widebody_pax_number_triple") > -1) {
    seatCode = "T19P85C";
  }

  //   console.log(seatCode);
  return seatCode;
}

export function getSeatDetails(dataSelection) {
  const seatTypeSelection =
    dataSelection?.["Product Installation"]?.["Seat Type"]?.["Seat Type"] || "";
  const consoleWidthSelection =
    dataSelection?.["Product Installation"]?.["Console Width"]?.[
      "Console Width"
    ] || "";
  return {
    seatTypeSelection: seatTypeSelection,
    consoleWidthSelection: consoleWidthSelection,
  };
}
